import axios from 'axios'
import { logger } from 'lib/logger'
import { useState } from 'react'

import { FormState } from '../../features/form/types'

export const useFormAPI = () => {
  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const post = (apiUrl: string, data: FormState) => {
    setLoading(true)
    const form_data = new FormData()

    for (let key in data) {
      form_data.append(key, data[key].toString())
    }

    return axios({
      method: 'post',
      url: apiUrl,
      data: form_data
    })
      .catch((error) => {
        logger.log('[Form/ResponseError]: ', error)
        setIsError(true)
      })
      .finally(() => setLoading(false))
  }
  return { loading, isError, post }
}
